"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScreenshotUrl = void 0;
/**
 * `bounding_box` is a free-form JSON column, so rows can predate (or sidestep)
 * the `x`/`y`/`width`/`height` validation the issue write path applies. The
 * screenshot endpoint 400s on any box missing one of those four numbers, which
 * would bake a dead link into an export rather than degrade to the uncropped
 * screenshot — so verify the shape here and drop the param when it doesn't fit.
 */
const isBoundingBox = (value) => {
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    const box = value;
    return ['x', 'y', 'width', 'height'].every(prop => typeof box[prop] === 'number' && Number.isFinite(box[prop]));
};
const getScreenshotUrl = (baseScreenshotURL, screenshotId, boundingBox) => {
    if (!baseScreenshotURL || !screenshotId) {
        return null;
    }
    const url = new URL(`${baseScreenshotURL}/api/screenshots/${screenshotId}`);
    if (isBoundingBox(boundingBox)) {
        const { x, y, width, height } = boundingBox;
        url.searchParams.set('boundingBox', JSON.stringify({ x, y, width, height }));
    }
    return url.toString();
};
exports.getScreenshotUrl = getScreenshotUrl;
//# sourceMappingURL=get-screenshot-url.js.map